var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRulouElectricWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a7331d8a-fd10-4141-91bb-7e4935c20d73",
    "data-name": "rulou_electric",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 177.06 196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e55c533d-25db-4d92-901b-22c50a749a64{fill:#fff;}.e55c533d-25db-4d92-901b-22c50a749a64,.e9a73478-d81d-484f-b6d6-c2f72c62468d,.ea5bf98e-e583-4549-b717-ffc0d2de1c9a{stroke:#fff;stroke-linejoin:round;}.e9a73478-d81d-484f-b6d6-c2f72c62468d,.ea5bf98e-e583-4549-b717-ffc0d2de1c9a{fill:none;}.e9a73478-d81d-484f-b6d6-c2f72c62468d{stroke-width:3px;}.ea5bf98e-e583-4549-b717-ffc0d2de1c9a{stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rulou_electric_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bcec501e-eef8-4790-abd1-8778fe6e0480",
    "data-name": "broasca_electrica copy"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "e55c533d-25db-4d92-901b-22c50a749a64",
    points: "51.69 126.54 26.59 126.54 18.98 195.5 51.69 126.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "e55c533d-25db-4d92-901b-22c50a749a64",
    points: "0.5 140.76 25.6 140.76 33.2 71.8 0.5 140.76"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e9a73478-d81d-484f-b6d6-c2f72c62468d",
    cx: 118.23,
    cy: 58.83,
    r: 57.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e9a73478-d81d-484f-b6d6-c2f72c62468d",
    cx: 118.23,
    cy: 58.83,
    r: 47.09
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "ea5bf98e-e583-4549-b717-ffc0d2de1c9a",
    points: "60.39 58.32 60.39 172.98 70.63 172.98 70.63 90.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e9a73478-d81d-484f-b6d6-c2f72c62468d",
    d: "M101.54,166.26",
    transform: "translate(-10.44 -2.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ea5bf98e-e583-4549-b717-ffc0d2de1c9a",
    x1: 60.39,
    y1: 161.27,
    x2: 70.63,
    y2: 161.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "ea5bf98e-e583-4549-b717-ffc0d2de1c9a",
    x1: 60.39,
    y1: 150.99,
    x2: 70.63,
    y2: 150.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "ea5bf98e-e583-4549-b717-ffc0d2de1c9a",
    x1: 60.9,
    y1: 140.73,
    x2: 70.11,
    y2: 140.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "ea5bf98e-e583-4549-b717-ffc0d2de1c9a",
    x1: 60.39,
    y1: 130.6,
    x2: 70.11,
    y2: 130.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "ea5bf98e-e583-4549-b717-ffc0d2de1c9a",
    x1: 70.63,
    y1: 119.97,
    x2: 60.39,
    y2: 119.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "ea5bf98e-e583-4549-b717-ffc0d2de1c9a",
    x1: 60.39,
    y1: 109.86,
    x2: 70.63,
    y2: 109.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "ea5bf98e-e583-4549-b717-ffc0d2de1c9a",
    x1: 70.63,
    y1: 99.78,
    x2: 60.9,
    y2: 99.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "ea5bf98e-e583-4549-b717-ffc0d2de1c9a",
    x1: 60.39,
    y1: 89.83,
    x2: 69.85,
    y2: 89.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "ea5bf98e-e583-4549-b717-ffc0d2de1c9a",
    cx: 118.23,
    cy: 58.83,
    r: 6.14
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulouElectricWhite);
export default __webpack_public_path__ + "static/media/rulou_electric_white.cb05e581fc3da387c53a4230b4e8b628.svg";
export { ForwardRef as ReactComponent };